import { Box } from '@mui/material';
import { SymbolLayoutToolbar } from './symbol-layout-toolbar';
import { TimeframeLayout } from './timeframe-layout';
import {
  SymbolFeedProvider,
  useSymbolFeedContext
} from './symbol-feed.context';
import { ChartUpdateStreamProvider } from '../chart/components/chart-update-stream.context';

const TimeframeSection = () => {
  const { chartUpdateStream } = useSymbolFeedContext();

  return (
    <ChartUpdateStreamProvider chartUpdateStream={chartUpdateStream}>
      <TimeframeLayout />
    </ChartUpdateStreamProvider>
  );
};

export const SymbolLayoutContent = () => {
  return (
    <SymbolFeedProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            flex: '0 0 auto'
          }}
        >
          <SymbolLayoutToolbar />
        </Box>

        <Box
          sx={{
            flex: '1 1 auto',
            position: 'relative',
            overflow: 'hidden',
            '& > div': {
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            }
          }}
        >
          <TimeframeSection />
        </Box>
      </Box>
    </SymbolFeedProvider>
  );
};
